var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2822 4.44422C16.589 4.69222 16.6366 5.14196 16.3886 5.44875L8.57196 15.1184L8.57026 15.1205C8.41816 15.3072 8.22624 15.4582 8.00772 15.5613C7.78914 15.6644 7.55005 15.7167 7.30802 15.7139C7.06203 15.7108 6.81991 15.6507 6.60122 15.5389C6.38321 15.4275 6.19408 15.2679 6.04708 15.0731C6.04667 15.0726 6.04625 15.072 6.04584 15.0715L3.59801 11.8542C3.35915 11.5402 3.42002 11.0921 3.73397 10.8532C4.04792 10.6144 4.49607 10.6752 4.73493 10.9892L7.18712 14.2122C7.20529 14.2364 7.22755 14.2547 7.2514 14.2668C7.27519 14.279 7.30049 14.2851 7.32557 14.2854C7.35025 14.2857 7.37455 14.2804 7.39814 14.2693C7.42157 14.2582 7.44367 14.2414 7.46215 14.2189C7.46233 14.2187 7.4625 14.2185 7.46268 14.2182L15.2777 4.55067C15.5256 4.24388 15.9754 4.19622 16.2822 4.44422Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckFilled);
export default __webpack_public_path__ + "static/media/check-filled.cfc8e14364f1551814b94351c9407e06.svg";
export { ForwardRef as ReactComponent };